import React, { SVGProps } from 'react';

const SvgCustomItaly = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 512 512'
		xmlSpace='preserve'
		width='1em'
		height='1em'
		className='svg-icon'
		{...props}>
		<rect width='170.667' height='512' x='0' fill='#009246' />
		<rect width='170.667' height='512' x='170.667' fill='#ffffff' />
		<rect width='170.667' height='512' x='341.333' fill='#ce2b37' />
	</svg>
);

export default SvgCustomItaly;
